/* eslint-disable no-restricted-imports, no-restricted-syntax */
import dayjs from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat.js'
import isBetween from 'dayjs/plugin/isBetween.js'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter.js'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore.js'
import localeData from 'dayjs/plugin/localeData.js'
import localizedFormat from 'dayjs/plugin/localizedFormat.js'
import minMax from 'dayjs/plugin/minMax.js'
import relativeTime from 'dayjs/plugin/relativeTime.js'
import timezone from 'dayjs/plugin/timezone.js'
import utc from 'dayjs/plugin/utc.js'
/* eslint-enable no-restricted-imports, no-restricted-syntax */

/* eslint-disable no-restricted-syntax, import/no-unassigned-import */
import 'dayjs/locale/fr.js'
import 'dayjs/locale/en.js'
/* eslint-enable no-restricted-syntax, import/no-unassigned-import */

/* eslint-disable import-x/no-named-as-default-member */
dayjs.extend(advancedFormat)
dayjs.extend(isBetween)
dayjs.extend(isSameOrAfter)
dayjs.extend(isSameOrBefore)
dayjs.extend(localizedFormat)
dayjs.extend(localeData)
dayjs.extend(minMax)
dayjs.extend(relativeTime)
dayjs.extend(timezone)
dayjs.extend(utc)
/* eslint-enable import-x/no-named-as-default-member */

export { dayjs }

/* eslint-disable-next-line no-restricted-imports */
export type { Dayjs } from 'dayjs'
